import { DropdownButton } from '@rcg/ui-components';
import { FILTERS_MODAL } from 'components/Scroller/constants';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
import PropTypes from 'prop-types';
import { useContext } from 'react';

/**
 * Used on mobile. Appears at the start of the list of filter buttons.
 * Opens a modal list of all filter buttons.
 *
 * @param {func} openFilter - the button's onClick fn
 * @param {string} className
 * @param {string} label - the button's text
 * @param {boolean} isStorybook - makes the button always visible in Storybook
 */

function AllFiltersButton({ openFilter, className, label, isStorybook = false, searchFilters, dataTestId }) {
	const { isTablet } = useContext(CruiseSelectionContext);

	if (!isStorybook && (!isTablet || (isTablet && searchFilters === FILTERS_MODAL))) return null;

	return (
		<DropdownButton
			className={className.concat(' all-filters-button')}
			selected={true}
			hideIcon={true}
			sx={{
				marginRight: '10px',
			}}
			onMouseUp={openFilter}
			onTouchEnd={openFilter}
			data-testid={dataTestId}
		>
			{label}
		</DropdownButton>
	);
}

AllFiltersButton.propTypes = {
	openFilter: PropTypes.func.isRequired,
	className: PropTypes.string,
	label: PropTypes.string.isRequired,
	isStorybook: PropTypes.bool,
	searchFilters: PropTypes.string,
	dataTestId: PropTypes.string,
};

export default AllFiltersButton;
